const STORAGE_KEY = 'yoda.changeModal.headerDetailsExpanded';

/**
 * Large-format card banner starts compact.
 * The choice is global: every card shares the same expanded or compact banner.
 */
export const DEFAULT_HEADER_DETAILS_EXPANDED = false;

export function loadHeaderDetailsExpanded(): boolean {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw === 'true')
            return true;
        if (raw === 'false')
            return false;
        return DEFAULT_HEADER_DETAILS_EXPANDED;
    } catch {
        return DEFAULT_HEADER_DETAILS_EXPANDED;
    }
}

export function saveHeaderDetailsExpanded(expanded: boolean): void {
    try {
        localStorage.setItem(STORAGE_KEY, expanded ? 'true' : 'false');
    } catch {
        // Ignore quota / private mode failures.
    }
}

/** Single-line banner tail: author, date, place, requester. */
export function compactHeaderMeta(parts: Array<string | null | undefined>): string {
    return parts
        .map((part) => String(part || '').trim())
        .filter(Boolean)
        .join(' · ');
}
